{
  "Settings": "Settings",
  "Select a tab": "Select a tab",
  "preferences": {
    "header": "Preferences",
    "baseCurrency": "Your base currency",
    "preferredLanguage": "Preferred language",
    "baselineDate": "Baseline date",
    "expectedDateFormats": "Import date formats",
    "expectedDateFormatsInfo": "Data formats in your imported files may differ. Please update the formats you expect to see in your files, so that we may use them to convert the dates to our internal format. We will try to apply them one by one until we see a proper date, starting from the topmost one and moving down.",
    "expectedDateFormatsAllowed": "You can use standard date formatting characters, like YYYY, MM, DD etc. For example, 'YYYY-MM-DD' or 'DD.MM.YYYY'. We support",
    "expectedDateFormatsAllowedLink": "all these formats.",
    "expectedDateFormatsError": "Please remove unsupported characters."
  },
  "simulations": {
    "header": "Simulations",
    "info": "The parameters below will be used in the simulations to calculate the future growth of your assets.",
    "slider": "Slider",
    "setDates": "Set the start and end dates for all your projects, simulations and the Slider.",
    "startDate": "Start date",
    "endDate": "End date",
    "inflation": "Inflation",
    "inflationEnabledDescription": "If enabled, the system will automatically increase all inflows and outflows by the specified percentage every year. This will not apply to inflows and outflows for which an individual increase rate is defined.",
    "disabled": "Disabled",
    "enabled": "Enabled",
    "simulatedInflationRate": "Simulated inflation rate (%)",
    "averageInflation": "Average inflation 1982-2022 across all OCED countries was 3.55%, 2.95% in the Eurozone and 1.89% in Germany.",
    "source": "Source ",
    "stockMarketGrowthRate": "Category growth rates",
    "simpleMode": "Simple mode: there is one overall growth rate which applies to all your assets (all accounts in the category).",
    "simpleMode2": "Research shows that long-term growth rates for the stock market from historical data are around 5-6% per year.",
    "advancedMode": "Expert mode: you can define individual growth rates for each asset. It will apply to this asset across all your accounts and non-isolated projects in the same category.",
    "advancedMode2": "If we cannot find an individual growth rate for an asset, we will apply the general growth rate (like in simple mode).",
    "simple": "Simple",
    "advanced": "Expert",
    "growthRate": "Category growth rate (%)",
    "stockDividends": "Stock dividends",
    "stockDividendsDescription": "Simple mode: there is one simulated dividend rate (in %) for all stocks (across all accounts). It will only be applied to stocks which yielded a dividend at least once in the past.",
    "stockDividendsDescription2": "Expert mode: set individual dividend rates (in %) for each stock. The app will only apply dividends to stocks defined here across your stocks accounts.",
    "dividendYield": "Dividend yield (%)",
    "symbol": "Symbol",
    "dividendPerYear": "Dividend (%)",
    "add": "Add",
    "save": "Save",
    "cancel": "Cancel"
  },
  "account": {
    "header": "Account",
    "saveChanges": "Save changes",
    "2fa": "Two-factor authentication",
    "changePassword": "Change password",
    "qrCode1": "Scan the QR code with your preferred authenticator app (such as",
    "qrCode2": "or",
    "manualEntry": "If you prefer to enter the code manually, use the following code:",
    "Enable": "Enable",
    "Enabled": "Enabled",
    "Email address": "Email address",
    "emailInfo": "Please have your email account ready when changing your email -- we will send you a confirmation code.",
    "pleaseEnterCode": "Please enter the confirmation code from your email.",
    "enterAuthCode": "Enter the code from your authenticator app once you are done:",
    "Confirm": "Confirm",
    "Submit": "Submit",
    "Username": "Username",
    "Password": "Password",
    "Enter your current password": "Enter your current password",
    "Please enter your current password.": "Please enter your current password.",
    "The new password cannot be the same as the current password.": "The new password cannot be the same as the current password.",
    "Enter new password": "Enter new password",
    "Repeat new password": "Repeat new password"
  },
  "billing": {
    "header": "Subscription",
    "title": "Subscription",
    "leadingText1": "We take your privacy seriously, therefore only our specialised payment provider has access to your payment data.",
    "leadingText2": "Please select one of the links below to manage your subscription directly with our provider Stripe. All links open in a new tab.",
    "currentSubscription": "Your current subscription",
    "upgradePlan": "Upgrade your plan",
    "paymentMethod": "Payment method",
    "downloadInvoices": "Download invoices",
    "cancelSubscription": "Cancel subscription"
  }
}
